module.exports = __webpack_public_path__ + "static/media/desktop-onboarding-1.c43b5527.svg";